var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{staticClass:"mt-16",attrs:{"justify":"center","align":"center"}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('h1',{staticClass:"display-3"},[_vm._v("404")]),_c('p',{staticClass:"subtitle-1"},[_vm._v("Oops, the page you're looking for doesn't exist.")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }